import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={26.078}
    height="6.9mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 65128 65129"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#2b2a29;stroke-width:943.899}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974342546560">
        <path
          d="M32565 41135c5054 0 9152-3837 9152-8570s-4098-8571-9152-8571-9152 3838-9152 8571 4098 8570 9152 8570zM32514 472c1551 0 2821 1227 2821 2727v13385c0 1500-1270 2727-2821 2727s-2821-1227-2821-2727V3199c0-1500 1270-2727 2821-2727zM54503 10058c1129 1030 1181 2765 118 3856l-9502 9739c-1063 1091-2858 1142-3987 112-1128-1027-1181-2762-117-3853l9501-9741c1063-1091 2858-1141 3987-113zM64655 33182c-54 1499-1366 2683-2916 2631l-13840-461c-1551-51-2776-1320-2722-2819s1366-2683 2916-2631l13840 461c1550 51 2775 1320 2722 2819zM19951 33261c-54 1499-1366 2684-2916 2632l-13840-462c-1550-51-2775-1318-2722-2818 54-1499 1366-2684 2917-2631l13839 460c1551 52 2776 1320 2722 2819zM23200 22797v1c-1093 1063-2888 1070-3989 13l-9828-9430c-1101-1057-1108-2792-15-3857s2889-1070 3989-14l9829 9431c1101 1055 1108 2792 14 3856zM32431 64657c1552 0 2822-1227 2822-2726V48544c0-1499-1270-2727-2822-2727-1551 0-2821 1228-2821 2727v13387c0 1499 1270 2726 2821 2726zM54420 55071c1129-1029 1182-2764 118-3855l-9500-9739c-1065-1092-2859-1142-3989-114-1128 1029-1181 2763-116 3854l9500 9740c1064 1091 2859 1142 3987 114zM23118 42332c-1094-1064-2888-1070-3990-13l-9827 9429c-1102 1057-1109 2792-15 3856v1c1093 1064 2888 1071 3989 14l9828-9431c1100-1056 1108-2791 15-3856z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
